import React from "react";
import "./Common_Banner.css";

const Common_Banner = ({ title }) => {
  return (
    <div className="common_banner">
      <div className="container">
        <h5>{title}</h5>
      </div>
    </div>
  );
};

export default Common_Banner;
